import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaDesdeFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('date-reporteCompras-hasta', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FEC. DESDE' htmlFor='date-reporteCompras-desde' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='fechaDesde'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='date-reporteCompras-desde'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaDesdeFormGroup)
